export const newBaseUrl = process.env.REACT_APP_EWA_BASE_URL
export const extendedAppUrl = process.env.REACT_APP_EWA_BASE_URL
export const walletPublicKey = process.env.REACT_APP_PADE_WALLET_PUBLIC_KEY
export const walletBaseUrl = process.env.REACT_APP_PADE_WALLET_BASE_URL
export const newArchBaseUrl = process.env.REACT_APP_NEW_ARCH_BASE_URL
